import { useContext, useEffect } from "react";

import { Box, IconButton } from "@mui/material";
import CardGridContext from "core/CardGridContext";

import { CardViewIcon, GridViewIcon } from "../Icons/Icons";
import { WORKSPACE_VIEW_CARD, WORKSPACE_VIEW_TABLE } from "./helpers";

export default function WorkspaceViewSelector({ workspaceMode, setWorkspaceMode, cardGridKey }) {
  const { getCardGridState, setCardGridState } = useContext(CardGridContext);

  useEffect(() => {
    setWorkspaceMode(getCardGridState()[cardGridKey] || WORKSPACE_VIEW_CARD);
  });

  const handleWorkspaceMode = (value) => {
    setWorkspaceMode(value);
    setCardGridState(cardGridKey, value);
  };

  return (
    <Box
      sx={{
        position: "relative",
        width: 94,
        height: 42,
        backgroundColor: "transparent",
        borderRadius: "999px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "4px",
        boxSizing: "border-box",
        border: "2px solid var(--mui-palette-primary-main)",
        "[data-mui-color-scheme='dark'] &": {
          border: "2px solid var(--mui-palette-primary-light)",
        },
      }}
    >
      {/* Sliding background */}
      <Box
        sx={{
          position: "absolute",
          top: 2,
          left: workspaceMode === WORKSPACE_VIEW_CARD ? 2 : "calc(50% + 3px)",
          width: "calc(50% - 5px)",
          height: "calc(100% - 4px)",
          borderRadius: "999px",
          transition: "left 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
          boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
          zIndex: 1,
          backgroundColor: "primary.main",
          "[data-mui-color-scheme='dark'] &": {
            backgroundColor: "primary.light",
          },
        }}
      />

      <Box
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          position: "relative",
          zIndex: 2,
        }}
      >
        <IconButton
          onClick={() => handleWorkspaceMode(WORKSPACE_VIEW_CARD)}
          aria-label="Switch to Card View"
          sx={{ padding: "7px" }}
        >
          <CardViewIcon
            sx={{
              color: workspaceMode === WORKSPACE_VIEW_CARD ? "secondary.contrastText" : "primary.main",
              transition: "color 0.3s ease-in-out",
              "[data-mui-color-scheme='dark'] &": {
                color: workspaceMode === WORKSPACE_VIEW_CARD ? "secondary.contrastText" : "primary.light",
              },
            }}
          />
        </IconButton>

        <IconButton
          onClick={() => handleWorkspaceMode(WORKSPACE_VIEW_TABLE)}
          aria-label="Switch to Grid View"
          sx={{ padding: "7px" }}
        >
          <GridViewIcon
            sx={{
              color: workspaceMode === WORKSPACE_VIEW_TABLE ? "secondary.contrastText" : "primary.main",
              transition: "color 0.3s ease-in-out",
              "[data-mui-color-scheme='dark'] &": {
                color: workspaceMode === WORKSPACE_VIEW_TABLE ? "secondary.contrastText" : "primary.light",
              },
            }}
          />
        </IconButton>
      </Box>
    </Box>
  );
}
